import Colors from "assets/Colors";
import { InputNumber } from "antd";
import { useBusinessContext } from "../../../BusinessApp";

function CustomInput(props) {
  const { decimalSeparator } = useBusinessContext();
  return (
    <InputNumber
      {...props}
      decimalSeparator={decimalSeparator}
      style={{
        height: "40px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        borderColor: props.valid
          ? Colors.notification_failed
          : Colors.background_dividers,
        borderRadius: "2px",
        borderStyle: "solid",
        ...props.style,
      }}
    />
  );
}

export default CustomInput;
